<template>
  <IPAddress v-if="ip" :ip="ip" link-style hide-flag :truncate="false" />
  <span v-else aria-hidden="true">-</span>
</template>

<script setup lang="ts">
// An IP address inside a sentence, with a hyphen while the address is unknown.
import IPAddress from "./IPAddress.vue";

defineProps<{
  ip?: string | null;
}>();
</script>
